import React from 'react';
import './ArchitecturalServices.css';
import Button from '../components/Button';
import useScrollToTop from '../components/useScrollToTop';
import ReusableLanding from '../components/ReusableLanding';
import image2 from '../img/kitchen_modern_classic.webp';
import { FaCube,FaGlobe, FaVideo, FaDesktop, FaVrCardboard, FaPlayCircle, FaWalking, FaMousePointer, FaShareAlt, FaEye, FaCommentDots, FaRocket, FaCheckCircle, FaFileDownload,  } from 'react-icons/fa'; // Import relevant icons
import { Link } from 'react-router-dom';

const VirtualToursWalkthroughs = () => {
    useScrollToTop();
    return (
        <>
            <ReusableLanding
                imageUrl={image2}
                title="Virtual Tours & Walkthroughs"
                description="Experience your architectural designs in a truly immersive and interactive way with our virtual tours and walkthroughs. We create engaging visualizations that allow you and your clients to explore building interiors and exteriors as if you were physically there."
            />
            <div>
                <h1 className='panorama-title'> Experience Our Interior Spaces</h1>
                <iframe width="100%" height="640" title='Interior' frameborder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://kuula.co/share/hKPPV/collection/71fnN?logo=1&info=1&fs=1&vr=0&thumbs=1&inst=0"></iframe>
                </div>

             <div>
      <h1 className='panorama-title'> Experience Our Interior Spaces</h1>
      <iframe title="Panorama" width="100%" height="640" frameborder="0" allow="xr-spatial-tracking; gyroscope; accelerometer" allowfullscreen scrolling="no" src="https://kuula.co/share/hJfkT?logo=1&info=1&fs=1&vr=0&sd=1&thumbs=1"></iframe>
    </div>
            <div className="architectural-services-page">
            
                <section className="services-overview">
                    <h2>Our Virtual Tour & Walkthrough Services</h2>
                    <p>We offer a range of dynamic virtual experiences to bring your architectural designs to life.</p>
                    <ul className="services-list">
                        <li><FaGlobe className="service-icon" /> <strong>360-Degree Tours:</strong> Interactive panoramic views of building interiors and exteriors, allowing users to navigate and explore every angle.</li>
                        <li><FaWalking className="service-icon" /> <strong>Walkthrough Animations:</strong> Animated visualizations that guide viewers through the building layout, showcasing the flow and spatial relationships in a cinematic way.</li>
                        <li><FaDesktop className="service-icon" /> <strong>Interactive Presentations:</strong> Engaging presentations incorporating virtual tours and animations, providing a dynamic and memorable way to showcase your designs to clients and stakeholders.</li>
                        <li><FaPlayCircle className="service-icon" /> <strong>Real-Time Rendering & Exploration:</strong> Dynamic visualizations that allow for interactive exploration of the 3D model in real-time, offering a high degree of user control.</li>
                        <li><FaVrCardboard className="service-icon" /> <strong>VR Integration:</strong> Virtual reality experiences that provide a fully immersive way to view and interact with your architectural designs, offering an unparalleled sense of presence.</li>
                    </ul>
                </section>

                <section className="benefits-section">
                    <h2>Benefits of Virtual Tours & Walkthroughs</h2>
                    <ul className="benefits-list">
                        <li className="card">
                            <div className="service-icon"><FaEye /></div>
                            <h3>Enhanced Engagement</h3>
                            <p>Providing an immersive and interactive experience that captivates viewers and leaves a lasting impression.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaCommentDots /></div>
                            <h3>Improved Understanding</h3>
                            <p>Helping clients and stakeholders visualize complex designs and spatial relationships in a clear and intuitive manner, reducing ambiguity.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaShareAlt /></div>
                            <h3>Remote Presentations & Accessibility</h3>
                            <p>Facilitating remote presentations, client meetings, and design reviews, allowing stakeholders from anywhere to experience the project virtually.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaRocket /></div>
                            <h3>Powerful Marketing and Sales Tool</h3>
                            <p>Creating compelling visuals for marketing materials, websites, and sales presentations, attracting potential clients and showcasing the project's full potential.</p>
                        </li>
                        <li className="card">
                            <div className="service-icon"><FaMousePointer /></div>
                            <h3>Interactive Exploration</h3>
                            <p>Empowering users to explore the design at their own pace and from their preferred viewpoints, leading to a deeper understanding and appreciation.</p>
                        </li>
                    </ul>
                </section>

                <section className="process-section">
                    <h2>Our Process</h2>
                    <p>Our streamlined process ensures the creation of engaging and effective virtual tours and walkthroughs.</p>
                    <ol className="process-list">
                        <li><FaCube className="process-icon" /> <strong>Model Preparation & Optimization:</strong> We optimize your 3D models for smooth and efficient performance within the virtual environment.</li>
                        <li><FaVideo className="process-icon" /> <strong>Tour & Walkthrough Creation:</strong> We develop interactive 360-degree tours, animated walkthroughs, or real-time exploration environments based on your needs.</li>
                        <li><FaCheckCircle className="process-icon" /> <strong>Review and Refinement:</strong> We present the virtual tour or walkthrough for your review and incorporate your feedback to ensure it meets your expectations.</li>
                        <li><FaFileDownload className="process-icon" /> <strong>Delivery & Integration:</strong> We provide you with the final virtual tour or walkthrough in a format suitable for your intended use (e.g., web embed, standalone file, VR platform integration).</li>
                    </ol>
                </section>

                <section className="portfolio-cta">
                    <h2>View Our Portfolio</h2>
                    <p>
                        Browse our portfolio to experience examples of our immersive virtual tours and walkthroughs and see how they bring architectural designs to life.
                    </p>
                    <Link to="/projects">
                        <button className="custom-button primary">View Portfolio</button>
                    </Link>
                    <p>Ready to offer your clients a truly immersive experience of your architectural designs? Contact us today to discuss your virtual tour and walkthrough needs.</p>
                    <a href="https://wa.me/918828531570" target="_blank" rel="noopener noreferrer">
                 <Button className="button-outlined">Contact Us</Button>
                </a>
                </section>
            </div>
        </>
    );
};

export default VirtualToursWalkthroughs;